export const bondTypeLabel = {
  eoinsurance: 'Errors and Omissions Insurance',
  bond: 'Bond',
  carinsurance: 'Car Insurance',
};

export enum BondTypeValue {
  eoinsurance = 'eoinsurance',
  bond = 'bond',
  carinsurance = 'carinsurance',
}
export interface IBondAndInsurance {
  id: string;
  type: BondTypeValue;
  issuingCompany: string;
  policyNumber: string;
  policyEffectiveDate: {
    start: string;
    expired: string;
  };
  thumbnail?: string[];
  details: IBondAndInsuranceDetails;
}

export interface IBondAndInsuranceDetails {
  bondType: string;
  company: string;
  policyEffectiveDate: string[];
  policyNo: string;
}
